import React from 'react';
import DataDrivenGuidePage from '../../components/guides/DataDrivenGuidePage';

const FuelConsumptionConverterGuidePage = () => <DataDrivenGuidePage slug="guide-fuel-consumption-calculator" />;

export default FuelConsumptionConverterGuidePage;
